module.exports = __webpack_public_path__ + "img/ron_h.914201f8.png";